import React, {useEffect} from "react";
import PageName from "../../component/common/page-name/page-name";
import {Link, useLocation} from "react-router-dom";
function ObstetricGynecology() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }, [location.pathname]);
    return (
        <>
            <PageName title="Obstetrics & Gyneacology" subTitle="Obstetrics & Gyneacology"/>
            <section id="info-1" className="wide-60 info-section division text-left">
                <div className="container">
                    <div className="row d-flex ">
                        <div className="col-lg-6">
                            <div className="info-1-img text-center mb-40 wow fadeInUp" data-wow-delay="0.6s" style={{ width: '800px', height: '500px', margin: '0 auto', overflow: 'hidden' }}>
                                <img
                                    src={require('../../images/antenatal.jpg')}
                                    alt="who-we-are"
                                    className="img-fluid w-100 h-100"
                                    style={{ objectFit: 'cover' }}
                                />
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="txt-block pc-30 mb-40 wow fadeInUp" data-wow-delay="0.4s">
                                <span className="section-id blue-color">Comprehensive Women's Health at Garkuwa Specialist Hospital</span>

                                <h3 className="h3-md steelblue-color">Obstetrics & Gyneacology</h3>


                                <p className="mb-30 text-justify">Our Obstetrics & Gynecology (OB/GYN) Department is
                                    dedicated to providing comprehensive, compassionate, and expert care for women at
                                    every stage of life. From prenatal care to advanced gynecological treatments, we
                                    prioritize women’s health and wellness.
                                </p>

                                <div className="mb-4"><h6>Our Services Include:</h6></div>
                                <div className="row">

                                    <div className="col-md-12">

                                        <div className="box-list m-top-15">
                                            <div className="box-list-icon blue-color"><i
                                                className="fas fa-angle-double-right"></i></div>
                                            <p className="p-sm">Prenatal & Maternity Care – Antenatal check-ups, labor management, and postnatal care.</p>
                                        </div>
                                        <div className="box-list">
                                            <div className="box-list-icon blue-color"><i
                                                className="fas fa-angle-double-right"></i></div>
                                            <p className="p-sm">Gynecological Examinations – Routine check-ups, Pap smears, and breast health screening.</p>
                                        </div>

                                        <div className="box-list">
                                            <div className="box-list-icon blue-color"><i
                                                className="fas fa-angle-double-right"></i></div>
                                            <p className="p-sm">Fertility & Reproductive Health – Treatment for infertility, family planning, and hormonal therapy.</p>
                                        </div>

                                        <div className="box-list">
                                            <div className="box-list-icon blue-color"><i
                                                className="fas fa-angle-double-right"></i></div>
                                            <p className="p-sm">Minimally Invasive Gynecologic Surgery – Laparoscopic procedures and fibroid removal.</p>
                                        </div>
                                        <div className="box-list">
                                            <div className="box-list-icon blue-color"><i
                                                className="fas fa-angle-double-right"></i></div>
                                            <p className="p-sm">Menopause & Hormonal Therapy – Managing symptoms for a healthy transition.</p>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                    <div className="mb-4 col-md-12"><h4>Why Choose Us?</h4></div>
                    <div className="row">

<div className="col-md-4">
    <div className="box-list m-top-15">
        <div className="box-list-icon blue-color"><i
            className="fas fa-dot-circle"></i></div>
        <p className="p-sm text-justify"><b>Expertise: </b>Our internists are skilled in the latest medical advancements and diagnostic techniques to offer you personalized and evidence-based care. </p>
    </div>
</div>
<div className="col-md-4">
    <div className="box-list">
        <div className="box-list-icon blue-color"><i
            className="fas fa-dot-circle"></i></div>
        <p className="p-sm text-justify"><b>Collaborative Care:</b> We work closely with other departments such as cardiology, nephrology, and endocrinology to ensure comprehensive management of multi-system diseases. </p>
    </div>
</div>

<div className="col-md-4">
    <div className="box-list">
        <div className="box-list-icon blue-color"><i
            className="fas fa-dot-circle"></i></div>
        <p className="p-sm text-justify"><b>Preventive Care:</b> We emphasize the importance of preventive medicine, offering routine check-ups, screenings, and health education to help patients manage risk factors and prevent disease. </p>
    </div>

</div>

</div>
                    <Link to='/book-appointment' className="btn btn-blue blue-hover mt-5"> <span className="fa fa-calendar-alt"/> Book an Appointment</Link>
                </div>
            </section>

        </>
    )
}

export default ObstetricGynecology;